import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import type GetCategoryProductsDto from "./dto/get-category-products.dto";

export const CategoryProductsEffectActions = {
  getCategoryProducts: `${Entities.CategoryProducts}_getCategoryProducts`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.CategoryProducts,
  initSchema,
  aliasName: DIContainerKeys.CategoryProductsService,
})
export class CategoryProductsService extends HttpService {
  @loader(Loaders.GetCategoryProductsLoader)
  @action(DIContainerKeys.CategoryProductsService)
  public *getCategoryProducts(dto: GetCategoryProductsDto): any {
    yield this.setLoaderState(Loaders.GetCategoryProductsLoader, true);
    const response = yield call(
      this.get,
      {
        url: BASE_API_PATHS.getProductsFromCategory,
        domain: API_DOMENS.PSA_API,
        params: {
          CategoryId: dto.categoryId,
          ProductsFor: dto.type,
        }
      },
      ReducerMethods.UPDATE
    );
    if (!response?.Success) {
      yield this.setLoaderState(Loaders.GetCategoryProductsLoader, false);
      return;
    }
    const state = yield this.di.reduxStore.state()?.[Entities.CategoryProducts]?.[dto.categoryId] ?? {};
    const payload = {
      ...state,
      [dto.type]: response?.Data,
    }
    yield this.setEntityStateById(Entities.CategoryProducts, dto.categoryId, payload);
    yield this.setLoaderState(Loaders.GetCategoryProductsLoader, false);
  }
}
